"use client";

import type { ComponentProps } from "react";
import { NextIntlClientProvider } from "next-intl";
import { IntlErrorCode } from "use-intl/core";

/**
 * Provides client-side i18n without reporting missing messages as errors.
 */
export function IntlClientProvider(props: ComponentProps<typeof NextIntlClientProvider>) {
	return (
		<NextIntlClientProvider
			{...props}
			onError={(error) => {
				if (error.code === IntlErrorCode.MISSING_MESSAGE) {
					return;
				}

				console.error(error);
			}}
			getMessageFallback={({ key, namespace }) => (namespace ? `${namespace}.${key}` : key)}
		/>
	);
}
